import { useState, useEffect, useRef } from 'react';
import { apiFetch } from '../lib/api.js';

export type BadgeVersionMap = Map<string, string>;
export type BadgeSetMap = Map<string, BadgeVersionMap>;

export interface BadgeData {
  badgeMap: BadgeSetMap;
  broadcasterAvatar: string | null;
}

interface BadgesResponse {
  badges: Record<string, Record<string, string>>;
  broadcasterAvatar: string | null;
}

export function useBadges(): BadgeData {
  const [data, setData] = useState<BadgeData>({ badgeMap: new Map(), broadcasterAvatar: null });
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    apiFetch<BadgesResponse>('/api/config/badges', { signal: ctrl.signal })
      .then((res) => {
        const badgeMap: BadgeSetMap = new Map();
        for (const [setId, versions] of Object.entries(res.badges)) {
          badgeMap.set(setId, new Map(Object.entries(versions)));
        }
        setData({ badgeMap, broadcasterAvatar: res.broadcasterAvatar });
      })
      .catch(() => {});
    return () => {
      ctrl.abort();
    };
  }, []);

  return data;
}
